// src/utils/dateUtils.js

/**
 * Formats duration in seconds to MM:SS format
 * Used in: CallSessionDetails, CallSessionMetrics, CallSessionSidebar
 */
export const formatDuration = (seconds) => {
    if (!seconds && seconds !== 0) return 'N/A';
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };
  
  /**
   * Formats a date string for display
   * Used in: CallSessionDetails, CallSessionMetrics, CallSessionSidebar
   */
  export const formatDate = (dateString, options = {}) => {
    if (!dateString) return 'N/A';
    
    const defaultOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    };
    
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { ...defaultOptions, ...options });
  };


    export const formatDateOnly = (dateString) => {
      if (!dateString) return 'N/A';
      
      // Extract just the date part (YYYY-MM-DD) and format it
      const datePart = dateString.split('T')[0]; // Gets "2025-09-23" from "2025-09-23T00:00:00.000Z"
      const [year, month, day] = datePart.split('-');
      
      return `${month}/${day}/${year}`;
    };
  
  /**
   * Formats date in short format for sidebar
   * Used in: CallSessionSidebar
   */
  export const formatDateShort = (dateString) => {
    return formatDate(dateString, {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };